import { Button, Switch, Text } from "@flat-ui";
import { TableCell, TableRow } from "@mui/material";
import { DevToolItem } from "@components/dev-features-dialog/features";
import {
  isToolButtonItem,
  isToolToggleItem,
} from "@components/dev-features-dialog/features-utils";

interface DevToolsTableRowProps {
  /** The tool item to display in the row */
  item: DevToolItem;
}

/**
 * @returns A row of the Dev tools table that allows to modify the tool state
 */
export function DevToolsTableRow({
  item,
}: DevToolsTableRowProps): React.JSX.Element {
  return (
    <TableRow key={item.label}>
      <TableCell
        sx={{
          "&.MuiTableCell-root": {
            pl: "12px",
          },
        }}
      >
        <Text variant="heading12">{item.label}</Text>
      </TableCell>
      <TableCell sx={{ p: 1 }}>
        <Text variant="helpText">{item.description}</Text>
      </TableCell>
      <TableCell sx={{ p: 1, textAlign: "center" }}>
        {isToolToggleItem(item) && (
          <Switch
            checked={!!item.isEnabled}
            onToggle={() => item.onToggle?.(!item.isEnabled)}
            label=""
            // Requires overflow hidden because it seems when toggled it grows a bit and causes layout shift
            sx={{ justifySelf: "end", overflow: "hidden" }}
          />
        )}
        {isToolButtonItem(item) && (
          <Button variant="secondary" onClick={item.onClick} size="s">
            {item.buttonText}
          </Button>
        )}
      </TableCell>
    </TableRow>
  );
}
